
WW.scrollMagic = function($) {
    'use strict';

    let runScrollMagic = () => {
        let controller,
            navbar,
            frontpageBannerContent,
            subpageBannerContent;

        controller = new ScrollMagic.Controller();

        // SITE HEADER
        navbar = TweenMax.fromTo('#siteHeader', 1,
            {
                height: 85,
                lineHeight: 85 + 'px'
            },
            {
                height: 60,
                lineHeight: 60 + 'px'
            });
        new ScrollMagic.Scene({
            duration: 500
        })
        .setTween(navbar)
        .addTo(controller);



        // SITE BANNER BANNER CONTENT
        frontpageBannerContent = TweenMax.to('#siteBannerContent', 1, {
            y: -200,
            opacity: 0,
            scale: 0.9
        });
        new ScrollMagic.Scene({
            duration: 1200
        })
        .setTween(frontpageBannerContent)
        .addTo(controller);



        // SUBPAGE BANNER BANNER CONTENT
        subpageBannerContent = TweenMax.to('#subpageBannerContent', 1, {
            y: -100,
            opacity: 0,
            scale: 0.85
        });
        new ScrollMagic.Scene({
            duration: 800
        })
        .setTween(subpageBannerContent)
        .addTo(controller);

    };

    !WW.isTouch && runScrollMagic();

    return this;
};
